import { useEffect } from "react";
import { BookingProvider } from "../context/BookingContext";
import { SmoothScroll } from "../components/site/SmoothScroll";
import { Header } from "../components/site/Header";
import { Hero } from "../components/site/Hero";
import { Marquee } from "../components/site/Marquee";
import { About } from "../components/site/About";
import { Services } from "../components/site/Services";
import { Packages } from "../components/site/Packages";
import { Portfolio } from "../components/site/Portfolio";
import { Films } from "../components/site/Films";
import { Testimonials } from "../components/site/Testimonials";
import { Terms } from "../components/site/Terms";
import { Booking } from "../components/site/Booking";
import { Footer } from "../components/site/Footer";
import { FloatingActions } from "../components/site/FloatingActions";

export default function Home() {
  useEffect(() => {
    document.title = "Glow Motion Pictures | Wedding Photographer & Videographer in Junagadh & Ahmedabad";
  }, []);
  return (
    <BookingProvider>
      <SmoothScroll />
      <div className="relative bg-cream text-ink" data-testid="home-page">
        <Header />
        <main>
          <Hero />
          <Marquee />
          <About />
          <Services />
          <Packages />
          <Portfolio />
          <Films />
          <Testimonials />
          <Terms />
          <Booking />
        </main>
        <Footer />
        <FloatingActions />
      </div>
    </BookingProvider>
  );
}
